/**
 * ─── LOYALTY PRICE COMPONENT JAVASCRIPT ───
 * Handles tooltip interactions for loyalty price info icons
 * Manages click-to-lock and click-outside-to-close behavior
 */

class LoyaltyPrice extends HTMLElement {
  constructor() {
    super();
    this.tooltipLocked = false;
    this.tooltip = this.querySelector('.loyalty-price-tooltip');
    this.infoIcon = this.querySelector('.loyalty-price-info-icon');
    this.closeButton = this.querySelector('.loyalty-price-tooltip-close');
    
    this.init();
  }

  init() {
    if (!this.tooltip || !this.infoIcon) return;

    // Toggle tooltip on info icon click
    this.infoIcon.addEventListener('click', this.toggleTooltip.bind(this));

    // Close tooltip on close button click
    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.closeTooltip.bind(this));
    }

    // Close tooltip when clicking outside
    document.addEventListener('click', this.handleOutsideClick.bind(this));
  }

  toggleTooltip(event) {
    event.stopPropagation();
    this.tooltipLocked = !this.tooltipLocked;
    
    if (this.tooltipLocked) {
      this.tooltip.classList.add('active');
    } else {
      this.tooltip.classList.remove('active');
    }
  }

  closeTooltip(event) {
    event.stopPropagation();
    this.tooltipLocked = false;
    this.tooltip.classList.remove('active');
  }

  handleOutsideClick(event) {
    if (!this.tooltipLocked) return;
    
    const clickedInside = this.contains(event.target);
    
    if (!clickedInside && this.tooltip.classList.contains('active')) {
      this.tooltipLocked = false;
      this.tooltip.classList.remove('active');
    }
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.handleOutsideClick.bind(this));
  }
}

customElements.define('loyalty-price', LoyaltyPrice);
